import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ProSidebarProvider } from "react-pro-sidebar";
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';

import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';

const theme = createTheme({
    palette: {
        primary: {
            light: '#17468C',
            main: '#082C91',
            dark: '#262673',
            contrastText: '#FFF',
        },
        secondary: {
            light: '#747676',
            main: '#747676',
            dark: '#747676',
            contrastText: '#ffffff',
        },
        c_yellow: {
            main: '#FFE04D',
            contrastText: '#1A204D'
        },
        c_button: {
            main: '#969EB6',
            bg: '#4d61b3',
            contrastText: '#FFF'
        },
        c_buttonA: {
            main: '#969EB6',
            bg: '#bac3de',
            contrastText: '#FFF'
        },
        c_buttonB: {
            main: '#969EB6',
            bg: '#4d61b3',
            contrastText: '#FFE04D'
        }
    },
    typography: {
        allVariants: {
            color: "#082C91"
        }
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ProSidebarProvider>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </ProSidebarProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
